import { useReportBlockList } from "@/services/reports/useReportBlockList";
import BlockList from "@/components/blocks/BlockList";
import LoadingDataBlock from "@/components/loading-pages/LoadingDataBlock";
import RenderBlock from "@/components/blocks/RenderBlock";

export interface BlockListManangerProps {
  reportId: number;
  readOnly?: boolean;
}

function BlockListMananger({ reportId, readOnly }: BlockListManangerProps) {
  const { blocks, status } = useReportBlockList(reportId);

  if (status === "loading") {
    return <LoadingDataBlock message="We laden de bouwblokken in je verslag" />;
  }
  if (!blocks) {
    return (
      <div className="flex items-center justify-center">
        <h2 className="leading-5 text-primary">
          Er ging iets mis tijdens het laden van je verslag.
        </h2>
      </div>
    );
  }
  return (
    <div>
      <span className="sr-only">Verslag met bouwblokken</span>
      <BlockList blocks={blocks}>
        {({ block }) => (
          <RenderBlock
            id={block.id}
            readOnly
            reportId={reportId}
            hideSettings
          />
        )}
      </BlockList>
    </div>
  );
}
export default BlockListMananger;
